module.exports = __webpack_public_path__ + "static/img/0-1home7.fb709575.png";